query MyPartnerAssistantConversation {
  myPartnerAssistantConversation {
    id
    messages {
      id
      role
      kind
      text
      cards
      ask
      createdAt
      attachments {
        id
        url
        width
        height
      }
      plan {
        id
        status
        title
        notes
        sources
        previews
        executedAt
        steps {
          index
          description
          operation
          dangerous
          dangerReason
          removedFrom
          status
          error
        }
      }
    }
  }
}
